import { useEffect } from "react";
import { useDispatch } from "react-redux";
import PageTitle from "../../components/Page/PageTitle";
import PageWrapper from "../../components/Page/PageWrapper";
import ManualSearchForm from "./ManualSearchForm/ManualSearchForm";
import ManualSearchTable from "./ManualSearchTable/ManualSearchTable";
import { clearManualSearch } from "../../redux/features/manualSearch/manualSearchSlice";
import { useTranslation } from "react-i18next";

const ManualSearch = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    return () => {
      dispatch(clearManualSearch());
    };
  }, [dispatch]);

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.manualSearch")} />
      <ManualSearchForm />
      <ManualSearchTable />
    </PageWrapper>
  );
};

export default ManualSearch;
